"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationPhoneCell = void 0;
const react_1 = __importDefault(require("react"));
const ReservationPhoneCell = (props) => {
    var _a, _b, _c;
    const { value } = props;
    const phones = [];
    if ((_a = value.phoneMobile) === null || _a === void 0 ? void 0 : _a.length) {
        phones.push(value.phoneMobile);
    }
    if ((_b = value.phoneNumberFirst) === null || _b === void 0 ? void 0 : _b.length) {
        phones.push(value.phoneNumberFirst);
    }
    if ((_c = value.phoneNumberSecond) === null || _c === void 0 ? void 0 : _c.length) {
        phones.push(value.phoneNumberSecond);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, phones.map((phone, key) => {
        return (react_1.default.createElement("div", { key: key }, phone));
    })));
};
exports.ReservationPhoneCell = ReservationPhoneCell;
//# sourceMappingURL=ReservationPhoneCell.js.map